export default "__VITE_ASSET__BTMP6sCj__"